<div>
	@if(showWarning) {
	<p class="warning">{{ text1 }}. {{ text2 }}</p>
	} @else {
	<p>{{ text1 }}. {{ text2 }}</p>
	} @if(showLink) {
	<a [href]="link" target="_blank" class="link">{{ linkLabel }}</a>
	}
</div>
